import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col justify-between" }
const _hoisted_2 = { class: "text-light font-bold my-3" }
const _hoisted_3 = {
  key: 1,
  class: "pt-text-light"
}
const _hoisted_4 = {
  key: 0,
  class: "text-light my-3"
}
const _hoisted_5 = { class: "h-10 my-3 px-0.5" }
const _hoisted_6 = {
  key: 1,
  class: "pt-text-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_percent_input = _resolveComponent("percent-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isProposalEditable)
        ? (_openBlock(), _createBlock(_component_currency_input, {
            key: 0,
            modelValue: _ctx.price,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.price) = $event)),
            currencySymbol: _ctx.currencySymbol,
            disabled: _ctx.isDisabled,
            changed: _ctx.priceMeta.dirty,
            valid: _ctx.priceMeta.valid
          }, null, 8, ["modelValue", "currencySymbol", "disabled", "changed", "valid"]))
        : _createCommentVNode("", true),
      (_ctx.showCostPrice && !_ctx.isProposalEditable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.price) + "; ", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showCostPrice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$te(`general.currency_symbol.${_ctx.weightBracket.price.currency}`) ? _ctx.$t(`general.currency_symbol.${_ctx.weightBracket.price.currency}`) : `${_ctx.weightBracket.price.currency}`) + " " + _toDisplayString(_ctx.costPrice), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.showGrossMargin && _ctx.isProposalEditable)
        ? (_openBlock(), _createBlock(_component_percent_input, {
            key: 0,
            modelValue: _ctx.grossMargin,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grossMargin) = $event)),
            disabled: _ctx.isDisabled,
            changed: _ctx.grossMarginMeta.dirty,
            valid: _ctx.grossMarginMeta.valid
          }, null, 8, ["modelValue", "disabled", "changed", "valid"]))
        : _createCommentVNode("", true),
      (_ctx.showGrossMargin && !_ctx.isProposalEditable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.grossMargin) + "; ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}